import makeFullscreen from "./util/requestFullscreen";

$(function() {
  $('.__gp__external-content-embed__fullscreen-button').on('click', function(e) {
    e.preventDefault();
    const iFrame = $(this).parent().find('iframe')[0];
    makeFullscreen(iFrame);
  });
});